import { render, staticRenderFns } from "./GetDistribute.vue?vue&type=template&id=b6a152b8&scoped=true"
import script from "./GetDistribute.vue?vue&type=script&lang=js"
export * from "./GetDistribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a152b8",
  null
  
)

export default component.exports